export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  directions: {
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    autogas_lpg: "Shell AutoGas",
    low_octane_gasoline: "Shell Unleaded 91",
    midgrade_gasoline: "Shell Unleaded 95 ",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell Diesel",
    super_premium_gasoline: "Shell Premium 98",
    truck_diesel: "Shell Diesel Extra",
    unleaded_super: "Shell Unleaded E10 "
  },
  amenities: {
    credit_card_diners_club: "Credit card - Diners Club",
    euroshell_card: "Shell Card Acceptance",
    high_speed_diesel_pump: "High Flow Diesel",
    service_bay: "K-Mart Tyre and Auto",
    shell_card: "Shell Card Acceptance",
    snack_food: "Snack Food",
    supermarket_fuel_discount: "Coles Express Fuel Discount",
    vacuum: "Vacuum",
    distance_units: {
      km: "kilometres"
    }
  }
}
